module.exports = __webpack_public_path__ + "./fonts/Montserrat-Medium.ttf";